export default __webpack_public_path__ + "static/media/blog1.aa2f074c.svg";